import { render, staticRenderFns } from "./KitchenTable.vue?vue&type=template&id=2517d10b&"
import script from "./KitchenTable.vue?vue&type=script&lang=js&"
export * from "./KitchenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports